import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import "./i18n";

// Material Dashboard 2 React Context Provider
import { SoftUIControllerProvider } from "context";
import AuthMiddleware from "middlewares/AuthMiddleware";
import { PermissionsProvider } from "context/PermissionsContext";
import { SweetAlertProvider } from "./hooks/useSweetAlert";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <SweetAlertProvider>
      <SoftUIControllerProvider>
        <AuthMiddleware>
          <PermissionsProvider>
            <App />
          </PermissionsProvider>
        </AuthMiddleware>
      </SoftUIControllerProvider>
    </SweetAlertProvider>
  </BrowserRouter>
);
